// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__21B55","spin":"Footer_spin__R8y8J","transition-opacity":"Footer_transition-opacity__1n8ll"};